const switchTeam = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="switchTeam-icon"
    height="40"
    viewBox="0 -960 960 960"
    width="40"
  >
    <path d="M547.608-486.538q44.939 0 76.371-31.17 31.431-31.17 31.431-75.955 0-44.784-31.278-76.22t-76.218-31.436q-44.939 0-75.984 31.217-31.045 31.217-31.045 75.886 0 44.888 30.892 76.283 30.891 31.395 75.831 31.395ZM300.706-240.514q-24.63 0-42.411-17.781-17.781-17.781-17.781-42.411v-494.357q0-24.631 17.781-42.411 17.781-17.781 42.411-17.781h494.357q24.631 0 42.411 17.781 17.781 17.78 17.781 42.411v494.357q0 24.63-17.781 42.411-17.78 17.781-42.411 17.781H300.706ZM164.937-104.745q-24.631 0-42.411-17.781-17.781-17.78-17.781-42.411v-526.869h47.883v526.869q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h526.869v47.883H164.937Zm135-183.652h495.896q-46.987-55.321-110.981-87.147-63.993-31.827-136.899-31.827t-136.967 31.827q-64.062 31.826-111.049 87.147Z" />
  </svg>
);

export default switchTeam;
